/**
 * Explicit Syntax Renderer — re-exported from @lokascript/intent
 */

export { renderExplicit, renderDocument } from '@lokascript/intent';
